module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_12-e17ac5e4dfe848007aafba8b6430bc53.svg";